import type { RefundLine as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';

/** Tickets of one type refunded at the same amount within a refund. */
export type RefundLine = {
  quantity: number;
  /** Includes the platform fee, as the legacy refund table showed it. */
  amount: number;
  ticketTypeName?: string;
  eventName?: string;
  /** Absent on an unseated event; a seated line may still carry an empty list. */
  seatLabels?: string[];
};

export const fromGql = (item: GQLItem): RefundLine => ({
  ...take<RefundLine>(item, 'quantity', 'amount', 'ticketTypeName', 'eventName'),
  seatLabels: item.seatLabels ?? undefined,
});
